import fromEntries from 'object.fromentries';

// Object.fromEntries() needs to be polyfilled to support older versions of Gemini-Desktop, which ship with
// older Electron/Chromium code that doesn't implement it.
// TODO: once music-metadata-browser libs are removed, we can upgrade core-js and remove this shim
if (!Object.fromEntries) {
  fromEntries.shim();
}
